// TODO: Refactor required.
export const priceFormatter = (locale, currency, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits
    });
  } catch (error) {
    console.warn(error);
    return Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits,
      maximumFractionDigits
    });
  }
};
export const formatMinutesAsDuration = minutes => {
  if (minutes < 0) {
    return ``;
  }
  const hours = minutes / 60;
  const completeHours = Math.floor(hours);
  const remainingMinutes = Math.round((hours - completeHours) * 60);
  return `${completeHours}h ${remainingMinutes}min`;
};